'use strict';

import { Entity } from '../Entity';

export class AgencySetting extends Entity {
  protected id;
  protected settingStaffQuota;
  protected settingStaffCount;
  protected settingCommunityActivities;
  protected agencyLeadStatusOverride;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.settingId;
    this.settingStaffQuota = data.settingStaffQuota;
    this.settingStaffCount = data.settingStaffCount;
    this.settingCommunityActivities = data.settingCommunityActivities;
    this.agencyLeadStatusOverride = data.agencyLeadStatusOverride;
  }

  public getSettingStaffQuota() {
    return this.settingStaffQuota;
  }

  public getSettingStaffCount() {
    return this.settingStaffCount;
  }

  public getSettingCommunityActivities() {
    return this.settingCommunityActivities;
  }

  public getAgencyLeadStatusOverride() {
    return this.agencyLeadStatusOverride;
  }
}
